export enum EstadoSuscripcion {
  Activo = 'Activo',
  Pausado = 'Pausado',
  Cancelado = 'Cancelado',
  Expirado = 'Expirado',
  EnGracia = 'EnGracia',
}

export enum tipoModuloSuscripcion {
  Incluido = 'Incluido',
  Adicional = 'Adicional',
}

export enum EstadoComprobantePago {
  Pendiente = 'Pendiente',
  Aprobado = 'Aprobado',
  Rechazado = 'Rechazado',
}

export enum AccionAuditoria {
  CREATE = 'CREATE',
  UPDATE = 'UPDATE',
  DELETE = 'DELETE',
  CHANGE_STATUS = 'CHANGE_STATUS',
  LOGIN = 'LOGIN',
  APPROVE = 'APPROVE',
  REJECT = 'REJECT',
  CRON_EXECUTION = 'CRON_EXECUTION',
}
